// show images on modal open
;
(function () {

    $(document)
        .on('modalOpened', function(e, modalTargetId) {
            var $modal = $('#' + modalTargetId);
            var $images = $('.js-m-modal-content-deeplinks-image', $modal);
            if (!$images.length) return false;

            $images.show();
        })
})();